import { cx, cva, type VariantProps } from 'class-variance-authority'

import styles from './loader.module.css'

const loaderVariants = cva('', {
  variants: {
    color: {
      default: 'bg-foreground',
      primary: 'bg-primary-500',
      secondary: 'bg-secondary',
    },
  },
  defaultVariants: {
    color: 'default',
  },
})

export type LoaderVariants = VariantProps<typeof loaderVariants>

type LoaderProps = React.ComponentProps<'div'> & LoaderVariants

export const Loader = (props: LoaderProps) => {
  const { className, color } = props

  return (
    <div className={cx('flex justify-center items-center', className)}>
      <div className={cx(styles.ldsEllipsis)}>
        <div className={cx(loaderVariants({ color }))} />
        <div className={cx(loaderVariants({ color }))} />
        <div className={cx(loaderVariants({ color }))} />
        <div className={cx(loaderVariants({ color }))} />
      </div>
    </div>
  )
}
